import { useEffect } from "react";

const useOutside = (
  contextMenuRef,
  moreButtonRef,
  moreButtonIconRef,
  callback = () => {},
  additionalRefs = []
) => {
  const handleClickOutside = (event) => {
    const allRefs = [
      contextMenuRef,
      moreButtonRef,
      moreButtonIconRef,
      ...(Array.isArray(additionalRefs) ? additionalRefs : []),
    ];

    if (!allRefs.some((ref) => ref?.current?.contains(event.target))) {
      callback();
    }
  };

  const handleKeyOutside = (event) => {
    const allRefs = [
      contextMenuRef,
      moreButtonRef,
      moreButtonIconRef,
      ...(Array.isArray(additionalRefs) ? additionalRefs : []),
    ];

    if (!allRefs.some((ref) => ref?.current?.contains(event.target))) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("mouseup", handleClickOutside);
    document.addEventListener("keyup", handleKeyOutside);

    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
      document.removeEventListener("keyup", handleKeyOutside);
    };
  }, [
    contextMenuRef,
    moreButtonRef,
    moreButtonIconRef,
    additionalRefs,
    callback,
  ]);
};

export default useOutside;
